import { transliterate } from "transliteration";

export default function transliterateToAscii(
	input,
	{ keepSpaces = true, upper = false, titleCase = false, translateCharactersBefore = [], maxLength = 35 } = {},
) {
	let s = transliterate(String(input ?? ""), { unknown: " ", replace: translateCharactersBefore });

	s = s.normalize("NFKD").replace(/\s+/g, " ").trim();

	if (titleCase) {
		s = s.toLowerCase().replace(/(^|[^A-Za-z0-9])([a-z])/g, (m, sep, chr) => sep + chr.toUpperCase());
	}

	const extraAllowed = translateCharactersBefore
		.map(([, to]) =>
			// escape for regex character-class
			to.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&"),
		)
		.join("");

	const allowed = keepSpaces ? `A-Za-z0-9 ${extraAllowed}` : `A-Za-z0-9${extraAllowed}`;

	s = s.replace(new RegExp(`[^${allowed}]+`, "g"), "");

	if (keepSpaces) {
		s = s.replace(/ +/g, " ");
	}
	if (upper) {
		s = s.toUpperCase();
	}
	if (maxLength) {
		s = s.slice(0, maxLength).trim();
	}
	return s;
}
